/**
 * Helper that prepends a section label and appends a separator.
 * Useful for grouping menu items with a heading.
 */
export function menuSection(label, items) {
    const labelId = `section-label-${label.toLowerCase().replace(/\s+/g, '-')}`;
    const separatorId = `section-sep-${label.toLowerCase().replace(/\s+/g, '-')}`;
    return [
        { type: 'label', id: labelId, text: label },
        ...items,
        { type: 'separator', id: separatorId },
    ];
}
